<template>
    <rkm-overlay>
        <rkm-layout-body title="Atividade coletiva">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'atencao-basica-atividade-coletiva-create' })"
                    autorize="store-atencao-basica-atividade-coletiva"
                    color="primary"
                >
                    Cadastrar atividade
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/atencao-basica/atividade-coletiva/List'

export default {
    components: { List },
}
</script>